/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LearningCompetenceTypeEnum,
    LearningCompetenceTypeEnumFromJSON,
    LearningCompetenceTypeEnumFromJSONTyped,
    LearningCompetenceTypeEnumToJSON,
} from './LearningCompetenceTypeEnum';

/**
 * 
 * @export
 * @interface CompetenceTemplateQueryParams
 */
export interface CompetenceTemplateQueryParams {
    /**
     * 
     * @type {number}
     * @memberof CompetenceTemplateQueryParams
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CompetenceTemplateQueryParams
     */
    pageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof CompetenceTemplateQueryParams
     */
    name?: string | null;
    /**
     * 
     * @type {LearningCompetenceTypeEnum}
     * @memberof CompetenceTemplateQueryParams
     */
    type?: LearningCompetenceTypeEnum;
}

export function CompetenceTemplateQueryParamsFromJSON(json: any): CompetenceTemplateQueryParams {
    return CompetenceTemplateQueryParamsFromJSONTyped(json, false);
}

export function CompetenceTemplateQueryParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetenceTemplateQueryParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : LearningCompetenceTypeEnumFromJSON(json['type']),
    };
}

export function CompetenceTemplateQueryParamsToJSON(value?: CompetenceTemplateQueryParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'name': value.name,
        'type': LearningCompetenceTypeEnumToJSON(value.type),
    };
}

